import { Storage as f } from "@fond-of/storage";
import { env as w } from "@fond-of/env";
function i(e) {
  this.message = e;
}
i.prototype = new Error(), i.prototype.name = "InvalidCharacterError";
var E = typeof window < "u" && window.atob && window.atob.bind(window) || function(e) {
  var t = String(e).replace(/=+$/, "");
  if (t.length % 4 == 1) throw new i("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var o, n, c = 0, a = 0, u = ""; n = t.charAt(a++); ~n && (o = c % 4 ? 64 * o + n : n, c++ % 4) ? u += String.fromCharCode(255 & o >> (-2 * c & 6)) : 0) n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(n);
  return u;
};
function h(e) {
  var t = e.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(o) {
      return decodeURIComponent(E(o).replace(/(.)/g, function(n, c) {
        var a = c.charCodeAt(0).toString(16).toUpperCase();
        return a.length < 2 && (a = "0" + a), "%" + a;
      }));
    }(t);
  } catch {
    return E(t);
  }
}
function s(e) {
  this.message = e;
}
function p(e, t) {
  if (typeof e != "string") throw new s("Invalid token specified");
  var o = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(h(e.split(".")[o]));
  } catch (n) {
    throw new s("Invalid token specified: " + n.message);
  }
}
s.prototype = new Error(), s.prototype.name = "InvalidTokenError";
const g = (e) => {
  if (w.isSSR)
    return null;
  const t = new URLSearchParams(window.location.search);
  return t.has(e) ? t.get(e) : null;
}, S = (e) => {
  if (w.isSSR)
    return;
  const t = new URLSearchParams(window.location.search);
  t.delete(e);
  const o = t.toString() ? `?${t.toString()}` : "", n = window.location.pathname + o + window.location.hash;
  window.history.replaceState(null, "", n);
}, l = "TOKEN_STORAGE_KEY", d = "signature", m = "uuid", C = "cart", _ = "checkoutAddress", T = "checkoutSuccess", A = "checkoutPayment", O = "triggerBeginCheckout", N = "loginConfirmed", R = "selectedPaymentMethod", r = f.create("localStorage"), I = () => {
  if (!r)
    throw new Error("Storage adapter not found");
  const e = g(d);
  return e ? (S(d), r.set(l, e)) : !1;
}, M = () => {
  if (!r)
    throw new Error("Storage adapter not found");
  r.delete(l), r.delete(m), r.delete(C), r.delete(T), r.delete(_), r.delete(A), r.delete(R), sessionStorage.removeItem(O), sessionStorage.removeItem(N);
}, y = () => {
  if (!r)
    throw new Error("Storage adapter not found");
  return r.get(l) || g(d);
}, k = (e) => {
  if (!e)
    return !0;
  const { exp: t } = p(e);
  return new Date(t * 1e3) < /* @__PURE__ */ new Date();
};
export {
  y as getToken,
  k as isTokenExpired,
  I as login,
  M as logout
};
//# sourceMappingURL=token-manager.js.map
